import { Progress } from '@mantine/core';
import type { UploadItemStatus } from '@/lib/constants/ingest';

interface UploadProgressBarProps {
  status: UploadItemStatus;
  uploadProgress: number;
  processingProgress: number;
}

export function UploadProgressBar({
  status,
  uploadProgress,
  processingProgress,
}: UploadProgressBarProps) {
  if (status === 'pending' || status === 'creating') {
    return <Progress value={0} size="sm" />;
  }

  if (status === 'error') {
    return <Progress value={100} size="sm" color="red" />;
  }

  if (status === 'cancelled') {
    return <Progress value={uploadProgress} size="sm" color="gray" />;
  }

  if (status === 'ready') {
    return <Progress value={100} size="sm" color="green" />;
  }

  if (status === 'processing') {
    // Green fills left→right as processing progresses, blue remainder shrinks
    return (
      <Progress.Root size="sm">
        <Progress.Section value={processingProgress} color="green" />
        <Progress.Section value={100 - processingProgress} color="blue" />
      </Progress.Root>
    );
  }

  // uploading
  return <Progress value={uploadProgress} size="sm" color="blue" animated />;
}
